import type { Lang } from "../types";

interface BannerProps {
  lang: Lang;
  strings: ReturnType<typeof import("../i18n").t>;
  position?: "bottom" | "bottom-left" | "bottom-right";
  policyUrl: string | null;
  onAccept: () => void;
  onReject: () => void;
  onCustomize: () => void;
}

export function renderBanner(root: HTMLElement, props: BannerProps): void {
  const { strings: s } = props;
  const bar = document.createElement("div");
  bar.className = `dp-bar dp-pos-${props.position ?? "bottom"}`;
  bar.innerHTML = `
    <div class="dp-grow">
      <div class="t"></div>
      <div class="d"></div>
    </div>
    <div class="dp-btns">
      <button class="dp-btn dp-link" data-act="customize"></button>
      <button class="dp-btn dp-reject" data-act="reject"></button>
      <button class="dp-btn dp-accept" data-act="accept"></button>
    </div>`;
  (bar.querySelector(".t") as HTMLElement).textContent = s.bannerTitle;
  const d = bar.querySelector(".d") as HTMLElement;
  d.textContent = s.bannerText;
  if (props.policyUrl && !/^\s*(javascript|data|vbscript):/i.test(props.policyUrl)) {
    d.append(" ");
    const a = document.createElement("a");
    a.className = "dp-link";
    a.target = "_blank";
    a.rel = "noopener";
    a.textContent = s.policyLink;
    a.href = props.policyUrl;
    d.appendChild(a);
  }
  const customize = bar.querySelector('[data-act="customize"]') as HTMLElement;
  customize.textContent = s.customize;
  const reject = bar.querySelector('[data-act="reject"]') as HTMLElement;
  reject.textContent = s.rejectAll;
  const accept = bar.querySelector('[data-act="accept"]') as HTMLElement;
  accept.textContent = s.acceptAll;
  accept.addEventListener("click", props.onAccept);
  reject.addEventListener("click", props.onReject);
  customize.addEventListener("click", props.onCustomize);
  root.appendChild(bar);
}
